import AddDashboardModal from './AddDashboardModal';

export default AddDashboardModal;